import {
	ScheduleComponent,
	ResourcesDirective,
	ResourceDirective,
	ViewsDirective,
	ViewDirective,
	ToolbarItemsDirective,
	ToolbarItemDirective,
	Inject,
	DragAndDrop,
	Day,
	Month,
	Week,
	Agenda,
	Resize,
} from '@syncfusion/ej2-react-schedule'
import { QuickInfoTemplate } from './QuickInfoTemplate.jsx'
import { EditorTemplate } from './EditorTemplate'

import './scheduler.css'
import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getKazooDate } from '../../features/kazooEventSlice.js'
import { useParams } from 'react-router-dom'
import { getKazooProposals } from '../../features/proposalSlice.js'

// Scheduler component integrates Syncfusion calendar with Redux state and backend logic
export const Scheduler = ({
	onActionBegin,
	eventSettings,
	partyMembers,
	editorTemplate,
	editorHeaderTemplate,
	editorFooterTemplate,
	showHeaderBar,
	currentView,
	dragStart,
	resizeStart,
	allowDragAndDrop,
	allowResizing,
	title,
	height,
	guestView,
	disableWeddingDateButton,
	isStaff = false,
}) => {
	const dispatch = useDispatch()
	const { kazooId } = useParams()
	const scheduleObj = useRef(null)

	const kazooDate = useSelector((s) => s.kazooEvent.kazooDate)

	const getContrastColor = (hexColor) => {
		if (!hexColor || hexColor.length !== 7) return '#ffffff'
		const r = parseInt(hexColor.slice(1, 3), 16)
		const g = parseInt(hexColor.slice(3, 5), 16)
		const b = parseInt(hexColor.slice(5, 7), 16)
		const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
		return luminance > 0.5 ? '#000000' : '#ffffff'
	}

	const handleGoWeddingDate = () => {
		if (scheduleObj.current)
			scheduleObj.current.selectedDate = new Date(kazooDate)
	}

	useEffect(() => {
		if (!disableWeddingDateButton && kazooId)
			dispatch(getKazooDate(kazooId))
		if (kazooId) dispatch(getKazooProposals(kazooId))
	}, [dispatch, kazooId])


	return (
		<>
			<ScheduleComponent
				timeScale={{ enable: true, interval: 60, slotCount: 4 }}
				ref={scheduleObj}
				currentView={currentView}
				showHeaderBar={showHeaderBar}
				cssClass="custom-scheduler"
				key={`${JSON.stringify(eventSettings?.dataSource?.slice(0, 2))} ${JSON.stringify(partyMembers)}`}
				group={{ resources: ['PartyMembers'] }}
				width="100%"
				eventSettings={eventSettings}
				eventRendered={(event) => {
					const element = event.element
					const color = event?.data?.EventColor || '#dfeef4'
					const textColor = getContrastColor(color)
					element.style.setProperty(
						'background-color',
						color,
						'important'
					)
					element.style.setProperty('color', textColor, 'important')
					element.style.setProperty(
						'border-left',
						`4px solid ${color}`,
						'important'
					)
				}}
				editorTemplate={editorTemplate || EditorTemplate}
				editorHeaderTemplate={editorHeaderTemplate}
				editorFooterTemplate={editorFooterTemplate}
				quickInfoTemplates={{ content: QuickInfoTemplate }}
				actionBegin={onActionBegin}
				dragStart={dragStart}
				resizeStart={resizeStart}
				allowDragAndDrop={allowDragAndDrop}
				allowResizing={allowResizing}
				allowSwiping={false}
				height={height}
			>
				{/* Calendar views */}
				<ViewsDirective>
					{!guestView && (
						<ViewDirective
							option="Day"
							displayName='<button class="calendar-btn">Day View</button> '
						/>
					)}
					{!guestView && (
						<ViewDirective
							option="Week"
							displayName='<button class="calendar-btn">Week View</button> '
						/>
					)}
					{!guestView && (
						<ViewDirective
							option="Month"
							displayName='<button class="calendar-btn">Month View</button> '
						/>
					)}
					{!isStaff && (
						<ViewDirective
							option="Agenda"
							displayName='<button class="calendar-btn">Agenda View</button> '
							allowVirtualScrolling={true}
						/>
					)}
				</ViewsDirective>

				{/* Party members */}
				<ResourcesDirective>
					<ResourceDirective
						field="OwnerId"
						title="Owner"
						name="PartyMembers"
						allowMultiple={true}
						dataSource={partyMembers}
						textField="OwnerText"
						idField="Id"
					/>
				</ResourcesDirective>

				{/* Scheduler header */}
				<ToolbarItemsDirective>
					{title && (
						<ToolbarItemDirective
							align="Left"
							text={title}
							id="task-title"
						/>
					)}
					{!disableWeddingDateButton && (
						<ToolbarItemDirective
							type="Button"
							align="Left"
							text="Wedding Date"
							id="kazoo-date"
							click={handleGoWeddingDate}
						/>
					)}
					<ToolbarItemDirective name="NewEvent" align="Left" />
					<ToolbarItemDirective name="Previous" align="Center" />
					<ToolbarItemDirective name="DateRangeText" align="Center" />
					<ToolbarItemDirective name="Next" align="Center" />
					<ToolbarItemDirective name="Views" align="Right" />
				</ToolbarItemsDirective>
				<Inject
					services={[Day, Week, Month, Agenda, DragAndDrop, Resize]}
				/>
			</ScheduleComponent>
		</>
	)
}
